import { useEffect } from "react";
import Lenis from "lenis";

/**
 * Global smooth-scroll (momentum) using Lenis on non-touch devices only.
 * On touch devices we let the browser handle native scrolling to avoid
 * the mobile "bounce down before up" glitch that syncTouch introduces.
 */
export default function SmoothScroll() {
    useEffect(() => {
        // Feature-detect touch primary input; skip Lenis on those devices.
        const isTouch =
            typeof window !== "undefined" &&
            (window.matchMedia?.("(hover: none) and (pointer: coarse)")?.matches ||
                "ontouchstart" in window ||
                navigator.maxTouchPoints > 0);

        // Anchor link handler works for both branches
        let lenis;
        let rafId;

        if (!isTouch) {
            lenis = new Lenis({
                duration: 1.2,
                easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
                smoothWheel: true,
                syncTouch: false,
                touchMultiplier: 0,
            });
            const raf = (time) => {
                lenis.raf(time);
                rafId = requestAnimationFrame(raf);
            };
            rafId = requestAnimationFrame(raf);
        }

        const onClick = (e) => {
            const a = e.target.closest?.('a[href^="#"]');
            if (!a) return;
            const id = a.getAttribute("href");
            if (!id || id === "#") return;
            const el = document.querySelector(id);
            if (el) {
                e.preventDefault();
                if (lenis) {
                    lenis.scrollTo(el, { offset: -60, duration: 1.4 });
                } else {
                    // native smooth scroll on mobile
                    const top =
                        el.getBoundingClientRect().top + window.pageYOffset - 60;
                    window.scrollTo({ top, behavior: "smooth" });
                }
            }
        };
        document.addEventListener("click", onClick);
        return () => {
            document.removeEventListener("click", onClick);
            if (rafId) cancelAnimationFrame(rafId);
            if (lenis) lenis.destroy();
        };
    }, []);
    return null;
}
